<template>
  <div class="company-cultrue">
    <div class="module-title">企业文化</div>
    <div class="module-text">
      让未来的天更蓝，未来的水更清，还人类一个青山绿水的世界！
    </div>
    <div class="module-list-content">
      <div class="module-list" :key="index" v-for="(item, index) in dataList">
        <img class="module-img" :src="application.imageHost + item.imagePath" />
        <div class="module-list-title">{{ item.name }}</div>
        <div class="module-list-text">
          {{ item.statement }}
        </div>
      </div>
    </div>
  </div>
</template>
<style src="./company-culture.css" scoped></style>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import mixins from "../../common/mixin";
import application from "../../common/application";
export default {
  name: "companyIntro",
  components: {
    swiper,
    swiperSlide,
  },
  data: () => ({
    dataList: [],
    application: application,
  }),
  mixins: [mixins],
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let data = {
        pageIndex: 0,
        pageSize: 30,
      };
      this.request({
        url: "/web/introduce/culture",
        data: data,
        success: (response) => {
          this.dataList = response.data.records;
          // console.log(this.bannerList)
        },
        error: (response) => {
          this.$Message.error(response.message);
        },
        complete: () => {},
      });
    },
  },
};
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/components/company-culture/company-culture.vue